import { styled, css, Box } from '@mui/material'

export const HeaderWrapper = styled(Box)(
  () => css`
    display: flex;
    padding: 12px 5px 0 20px;
  `
)

export const HeaderItem = styled(Box)(
  ({ theme }) => css`
    display: flex;
    color: ${theme.palette.text.primary};
    font-size: 11px;
    font-weight: 700;
    &.SummaryHeader-0 {
      flex: 0.5;
    }
    &.SummaryHeader-1 {
      flex: 2;
    }
    &.SummaryHeader-2 {
      flex: 0;
    }
  `
)
